import ReportBuilderEmbed from './views/ReportBuilderEmbed.vue';

const routes = [
  {
    name: 'report-builder-embed',
    path: '/embed/reports',
    component: ReportBuilderEmbed,
  },
];

export default routes;
